<div class="add-product-modal">
  <form [formGroup]="productForm" novalidate [ngClass]="{ 'was-validated': validate }">
    <div class="row g-4">
      <div class="col-xl-4 d-flex flex-column gap-3">
        <section class="pf-card pf-sidebar-card">
          <div
            class="pf-image-upload"
            [class.has-image]="currentImageUrl"
            (click)="triggerImageUpload(imageInput)"
            role="button"
            tabindex="0">
            <img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="" class="pf-image-preview" />
            <ng-container *ngIf="!currentImageUrl">
              <div class="pf-image-placeholder-icon">
                <i class="fa fa-image"></i>
              </div>
              <p class="pf-image-title">
                {{ curentLang === 'en' ? 'Add a main product image' : (curentLang === 'ar' ? 'أضف صورة رئيسية للمنتج' : 'הוסף תמונת מוצר ראשית') }}
              </p>
              <p class="pf-image-hint">
                {{ curentLang === 'en' ? 'Drag & drop or click to upload (320×650px recommended)' : (curentLang === 'ar' ? 'اسحب وأفلت أو انقر للرفع (320×650px)' : 'גרור ושחרר או לחץ להעלאה (320×650px)') }}
              </p>
            </ng-container>
            <input #imageInput type="file" accept="image/*" class="d-none" (change)="onProductImageSelected($event)" />
          </div>
          <div class="pf-image-actions">
            <button
              type="button"
              class="btn pf-btn-ai"
              [disabled]="!canGenerateAiImage()"
              (click)="generateAiImage(); $event.stopPropagation()">
              <i class="fa fa-magic"></i>
              {{ curentLang === 'en' ? 'Use AI' : (curentLang === 'ar' ? 'Use AI' : 'Use AI') }}
            </button>
            <button
              type="button"
              class="btn pf-btn-icon"
              [disabled]="!canGenerateAiImage()"
              (click)="generateAiImage(); $event.stopPropagation()"
              title="AI">
              <i class="fa fa-magic"></i>
            </button>
          </div>
          <div class="pf-ai-note">
            <i class="fa fa-lightbulb-o"></i>
            <span>{{ aiImageHint() }}</span>
          </div>
          <small *ngIf="pendingPreviewKey" class="text-success d-block mt-2">
            {{ curentLang === 'en' ? 'Preview ready — will apply on save' : (curentLang === 'ar' ? 'المعاينة جاهزة — تُعتمد عند الحفظ' : 'התצוגה מוכנה — תוחל בשמירה') }}
          </small>

          <div class="pf-sidebar-divider"></div>

          <div class="pf-toggle-row">
            <div class="pf-toggle-info">
              <span class="pf-toggle-label">
                <i class="fa fa-cube pf-toggle-icon"></i>
                {{ curentLang === 'en' ? 'Product status' : (curentLang === 'ar' ? 'حالة المنتج' : 'סטטוס מוצר') }}
              </span>
              <small class="pf-toggle-hint">
                {{ productForm.value.is_product_active
                  ? (curentLang === 'en' ? 'Active product' : (curentLang === 'ar' ? 'منتج نشط' : 'מוצר פעיל'))
                  : (curentLang === 'en' ? 'Inactive product' : (curentLang === 'ar' ? 'منتج غير نشط' : 'מוצר לא פעיל')) }}
              </small>
            </div>
            <label class="pf-toggle-wrap">
              <input type="checkbox" class="pf-toggle-input" formControlName="is_product_active" />
              <span class="pf-toggle-switch"></span>
            </label>
          </div>

          <div class="pf-sidebar-divider"></div>

          <div class="pf-toggle-row">
            <div class="pf-toggle-info">
              <span class="pf-toggle-label">
                {{ curentLang === 'en' ? 'Display in cashier?' : (curentLang === 'ar' ? 'عرض في الكاشير؟' : 'הצג בקופה?') }}
                <i class="fa fa-question-circle pf-help-icon"></i>
              </span>
            </div>
            <label class="pf-toggle-wrap">
              <input type="checkbox" class="pf-toggle-input" formControlName="show_in_pos" />
              <span class="pf-toggle-switch"></span>
            </label>
          </div>
        </section>
      </div>

      <div class="col-xl-8 d-flex flex-column gap-3">
        <section class="pf-card">
          <div class="pf-field pf-field-full">
            <div class="pf-field-inner">
              <span class="pf-field-icon"><i class="fa fa-font"></i></span>
              <input
                class="pf-input"
                type="text"
                formControlName="product_name_he"
                maxlength="80"
                [placeholder]="curentLang === 'en' ? 'Product name' : (curentLang === 'ar' ? 'اسم المنتج' : 'שם מוצר')" />
            </div>
            <div
              *ngIf="productForm.get('product_name_he')?.invalid && productForm.get('product_name_he')?.touched"
              class="text-danger small mt-1">
              {{ curentLang === 'en' ? 'Product name is required' : (curentLang === 'ar' ? 'اسم المنتج مطلوب' : 'שם המוצר נדרש') }}
            </div>
          </div>

          <div class="row g-3 mt-1">
            <div class="col-md-4">
              <div class="pf-field">
                <div class="pf-field-inner">
                  <span class="pf-field-icon"><i class="fa fa-barcode"></i></span>
                  <input
                    class="pf-input"
                    type="text"
                    formControlName="barcode"
                    maxlength="64"
                    [placeholder]="curentLang === 'en' ? 'Barcode' : (curentLang === 'ar' ? 'باركود' : 'ברקוד')" />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pf-field">
                <div class="pf-field-inner">
                  <span class="pf-field-icon"><i class="fa fa-qrcode"></i></span>
                  <input
                    class="pf-input"
                    type="text"
                    formControlName="product_code"
                    maxlength="20"
                    [placeholder]="curentLang === 'en' ? 'SKU' : (curentLang === 'ar' ? 'كود المنتج SKU' : 'SKU')" />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="pf-field">
                <div class="pf-field-inner">
                  <span class="pf-field-icon"><i class="fa fa-tag"></i></span>
                  <input
                    class="pf-input"
                    type="number"
                    formControlName="price"
                    [placeholder]="curentLang === 'en' ? 'Product price' : (curentLang === 'ar' ? 'سعر المنتج' : 'מחיר מוצר')" />
                </div>
                <div
                  *ngIf="productForm.get('price')?.invalid && productForm.get('price')?.touched"
                  class="text-danger small mt-1">
                  {{ curentLang === 'en' ? 'Price is required' : (curentLang === 'ar' ? 'السعر مطلوب' : 'מחיר נדרש') }}
                </div>
              </div>
            </div>
          </div>

          <div class="row g-3 mt-1">
            <div class="col-md-6">
              <label class="pf-field-label">
                {{ curentLang === 'en' ? 'Categories' : (curentLang === 'ar' ? 'التصنيفات' : 'קטגוריות') }}
              </label>
              <div class="pf-field pf-field-full">
                <div class="pf-field-inner pf-field-select">
                  <span class="pf-field-icon pf-field-icon-category">
                    <img
                      *ngIf="selectedMerchantCategoryImageUrl() as categoryImg"
                      [src]="categoryImg"
                      alt=""
                      class="pf-field-icon-img" />
                    <i *ngIf="!selectedMerchantCategoryImageUrl()" class="fa fa-folder-open"></i>
                  </span>
                  <ng-select
                    formControlName="merchant_category_id"
                    appendTo="body"
                    [clearable]="false"
                    [searchable]="false"
                    class="pf-select-inline flex-grow-1 pf-ng-dropdown-panel pf-ng-add-option"
                    (change)="onMerchantCategoryChange($event)"
                    [placeholder]="curentLang === 'en' ? 'Categories' : (curentLang === 'ar' ? 'التصنيفات' : 'קטגוריות')">
                    <ng-option *ngFor="let item of merchantCategoriesData" [value]="merchantCategoryPk(item)">
                      {{ merchantCategoryLabel(item) }}
                    </ng-option>
                    <ng-option [value]="addCategoryOptionValue">
                      {{ addCategoryLabel() }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label class="pf-field-label">
                {{ curentLang === 'en' ? 'Company name' : (curentLang === 'ar' ? 'اسم المصلحة التجارية' : 'שם החברה') }}
                <span class="text-danger">*</span>
              </label>
              <div class="pf-field pf-field-full">
                <div class="pf-field-inner pf-field-select">
                  <span class="pf-field-icon"><i class="fa fa-building"></i></span>
                  <ng-select
                    formControlName="company_id"
                    appendTo="body"
                    [clearable]="false"
                    [searchable]="false"
                    class="pf-select-inline flex-grow-1 pf-ng-dropdown-panel"
                    [placeholder]="curentLang === 'en' ? 'Company name' : (curentLang === 'ar' ? 'اسم المصلحة التجارية' : 'שם החברה')">
                    <ng-option *ngFor="let item of companiesData" [value]="item?.company_id">
                      {{ companyLabel(item) }}
                    </ng-option>
                  </ng-select>
                </div>
                <div
                  *ngIf="productForm.get('company_id')?.invalid && productForm.get('company_id')?.touched"
                  class="text-danger small mt-1">
                  {{ curentLang === 'en' ? 'Company is required' : (curentLang === 'ar' ? 'اسم المصلحة التجارية مطلوب' : 'שם החברה נדרש') }}
                </div>
                <div *ngIf="companyLocked" class="text-muted small mt-1">
                  {{ curentLang === 'en' ? 'Filled from the current document' : (curentLang === 'ar' ? 'تم تعبئتها من المستند الحالي' : 'מולא מהמסמך הנוכחי') }}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="pf-card">
          <h3 class="pf-section-title">
            {{ curentLang === 'en' ? 'Product details' : (curentLang === 'ar' ? 'تفاصيل المنتج' : 'פרטי מוצר') }}
          </h3>
          <textarea
            class="pf-description-input"
            formControlName="des_he"
            rows="6"
            maxlength="600"
            [placeholder]="curentLang === 'en' ? 'Enter product description' : (curentLang === 'ar' ? 'أدخل وصف المنتج' : 'הזן תיאור מוצר')">
          </textarea>
          <div
            *ngIf="productForm.get('des_he')?.invalid && productForm.get('des_he')?.touched"
            class="text-danger small mt-2">
            {{ curentLang === 'en' ? 'Description is required' : (curentLang === 'ar' ? 'الوصف مطلوب' : 'תיאור נדרש') }}
          </div>
        </section>

        <section class="pf-card pf-advanced-section">
          <details class="pf-advanced" open>
            <summary class="pf-advanced-summary">
              {{ curentLang === 'en' ? 'Advanced options' : (curentLang === 'ar' ? 'خيارات متقدمة' : 'אפשרויות מתקדמות') }}
            </summary>
            <div class="row g-3 mt-2">
              <div class="col-md-6">
                <label class="pf-field-label">
                  {{ curentLang === 'en' ? 'General category' : (curentLang === 'ar' ? 'التصنيف العام' : 'קטגוריה כללית') }}
                </label>
                <div class="pf-field-inner pf-field-select-block">
                  <ng-select
                    formControlName="categories_id"
                    appendTo="body"
                    [clearable]="true"
                    [searchable]="false"
                    class="pf-select-block pf-ng-dropdown-panel"
                    [placeholder]="curentLang === 'en' ? 'Select category' : (curentLang === 'ar' ? 'اختر التصنيف' : 'בחר קטגוריה')">
                    <ng-option *ngFor="let item of categoriesData" [value]="item?.categories_id">
                      {{ generalCategoryLabel(item) }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="col-md-6">
                <label class="pf-field-label">
                  {{ curentLang === 'en' ? 'Measurement unit' : (curentLang === 'ar' ? 'وحدة القياس' : 'יחידת מידה') }}
                  <span class="text-danger">*</span>
                </label>
                <div class="pf-field-inner pf-field-select-block">
                  <ng-select
                    formControlName="measurement_unit_id"
                    appendTo="body"
                    [clearable]="false"
                    [searchable]="false"
                    class="pf-select-block pf-ng-dropdown-panel"
                    [placeholder]="curentLang === 'en' ? 'Select unit' : (curentLang === 'ar' ? 'اختر وحدة القياس' : 'בחר יחידה')">
                    <ng-option *ngFor="let item of unitMesauereData" [value]="item.measurement_unit_id">
                      {{ measurementUnitLabel(item) }}
                    </ng-option>
                  </ng-select>
                </div>
                <div
                  *ngIf="productForm.get('measurement_unit_id')?.invalid && productForm.get('measurement_unit_id')?.touched"
                  class="text-danger small mt-1">
                  {{ curentLang === 'en' ? 'Measurement unit is required' : (curentLang === 'ar' ? 'وحدة القياس مطلوبة' : 'יחידת מידה נדרשת') }}
                </div>
              </div>
            </div>
          </details>
        </section>
      </div>
    </div>

    <div class="add-product-modal-actions">
      <button type="button" class="btn pf-btn-primary" [disabled]="isLoading" (click)="addedData()">
        <i class="fa fa-plus-circle"></i>
        {{ curentLang === 'en' ? 'Add Product' : (curentLang === 'ar' ? 'إضافة منتج' : 'הוספת מוצר') }}
      </button>
      <button type="button" class="btn btn-danger" [disabled]="isLoading" (click)="onCancel()">
        {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
        <i class="fa fa-rotate-left mx-1"></i>
      </button>
    </div>
  </form>
</div>

<ng-template #aiPreviewModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color: grey;">
      {{ curentLang === 'en' ? 'AI Image Preview' : (curentLang === 'ar' ? 'معاينة صورة AI' : 'תצוגה מקדימה של תמונת AI') }}
    </h6>
    <button type="button" class="close btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <img *ngIf="aiPreviewUrl" [src]="aiPreviewUrl" alt="AI preview" class="product-ai-preview" />
    <p class="text-muted mt-2 mb-0">
      {{ curentLang === 'en' ? 'Approve to save this image on the product.' : (curentLang === 'ar' ? 'اعتمد لحفظ هذه الصورة على المنتج.' : 'אשר כדי לשמור את התמונה על המוצר.') }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm pf-btn-primary" (click)="approveAiImage(modal)">
      {{ curentLang === 'en' ? 'Approve' : (curentLang === 'ar' ? 'اعتماد' : 'אישור') }}
      <i class="fa fa-check-circle mx-1"></i>
    </button>
    <button type="button" class="btn btn-sm btn-danger" (click)="modal.close()">
      {{ curentLang === 'en' ? 'Cancel' : (curentLang === 'ar' ? 'إلغاء' : 'ביטול') }}
    </button>
  </div>
</ng-template>

<p-toast></p-toast>
